import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

@Directive({ selector: '[kienePermission]' })
export class KienePermissionDirective implements OnInit, OnDestroy {
    private permissionIds: number[] = [];
    private strict = false;
    private sessionSub?: Subscription;

    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private localStorageService: LocalStorageService,
    ) {}

    ngOnInit(): void {
        this.sessionSub = this.localStorageService.watchCurrentUser().subscribe(() => this.updateView());
    }

    ngOnDestroy(): void {
        this.sessionSub?.unsubscribe();
    }

    @Input('kienePermission')
    set permissionIdsInput(ids: number[]) {
        this.permissionIds = ids;
        this.updateView();
    }

    /** Sonderrechte: Admin-Kurzschluss aus, nur echte Recht-IDs in der Session. */
    @Input()
    set kienePermissionStrict(value: boolean) {
        this.strict = !!value;
        this.updateView();
    }

    private updateView(): void {
        this.viewContainer.clear();
        if (Array.isArray(this.permissionIds) && this.permissionIds.length > 0 && this.isAllowed()) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
    }

    private isAllowed(): boolean {
        if (this.strict) {
            return this.permissionIds.some(id => this.localStorageService.currentUserHasExplicitPermission(Number(id)));
        }
        return this.localStorageService.currentUserHasPermissions(this.permissionIds);
    }
}
